import { render, staticRenderFns } from "./Doacoes.vue?vue&type=template&id=e6b26df2"
import script from "./Doacoes.vue?vue&type=script&lang=js"
export * from "./Doacoes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports